// extracted by mini-css-extract-plugin
export var layoutContainer = "_bf-0";
export var layoutContainerNoRounding = "_bf-6";
export var layoutContainerOpen = "_bf-5";
export var layoutContainerResizing = "_bf-1";
export var mainContent = "_bf-2";
export var resizeDivider = "_bf-3";
export var slidePanel = "_bf-4";